export default "__VITE_ASSET__CHshFT48__"